declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/omnichannel.scss';

import { h, Component } from 'preact';

export default class Omnichannel extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction"><a href={ BASE_URL + 'contacts' } class="butt huge">Contact us</a></p>;

        return <div id="omnichannel" class="product">
          <div class="mainWrp">
            <section class="body center">
              <h1>Omni-channel customer experience</h1>
              <h2 class="content">
                Want to engage with your customers seamlessly from all channels?​
              </h2>
              { calltoaction }
          </section>
          </div>
          <div class="mainWrp colsWrp">
            <section class="circleSection">
              <div class="col">
                
                <div class="circleWrp">
                  <div class="circleWrpWrp">
                    <h3>Omni-channel</h3>
                    <ul class="circleGroup">
                      <li id="callcenter">
                        <div><img alt="call center" src={ STATIC_BASE_URL + 'images/public/icons/ico_callcenter.png' } /></div>
                        <p>Call Center</p>
                      </li>
                      <li id="social">
                        <div><img alt="social" src={ STATIC_BASE_URL + 'images/public/icons/ico_social.png' } /></div>
                        <p>Social</p>
                      </li>
                      <li id="retailer">
                        <div><img alt="retailer" src={ STATIC_BASE_URL + 'images/public/icons/ico_retailer.png' } /></div>
                        <p>Retailer</p>
                      </li>
                      <li id="chatbots">
                        <div><img alt="chatbots" src={ STATIC_BASE_URL + 'images/public/icons/ico_chatbots.png' } /></div>
                        <p>Chatbots</p>
                      </li>
                      <li id="webportal">
                        <div><img alt="web portal" src={ STATIC_BASE_URL + 'images/public/icons/ico_webportal.png' } /></div>
                        <p>Web Portal</p>
                      </li>
                      <li id="mobile">
                        <div><img alt="mobile" src={ STATIC_BASE_URL + 'images/public/icons/ico_mobile.png' } /></div>
                        <p>Mobile</p>
                      </li>
                    </ul>
                  </div>
                </div>
  
              </div>
              <div class="col padLeft">
                <h2>Let Querlo help you build a platform to achieve that!</h2>
                <p>The Querlo Omni-channel platform engages with your customers and visitors and improve their digital experience.</p>
                <p>
                  It facilitates B2B, B2C and B2E transactions across all communication channels and languages.
                </p>
                <p>
                  In today's trust economy, the omnichannel experience is imperative. Customers have the power of telling businesses what they need. The omnichannel service enables customers to get on demand information fast and efficient. Consumers are no longer loyal to a single channel but to a multi-channel seamless experience.
                </p>
              </div>
              <br style="clear:both" />

            </section>
          </div>
          <section class="full grey">
            <p>
              Omnichannel comes into play with this new dynamic by customizing every customer experience and keeping customer retention high.Personalized customer experiences are particularly suitable for larger businesses that have no time to interact on a one to one level with each individual customer. Omnichannel enables this by allowing multiple existing channels to work together to help the customer improve their own experience.
            </p>
            <p>
              When customer satisfaction builds on, words result in spreading quickly among friends, family, and social media, encouraging other people who have never known about these opportunities to reach out to your business.
            </p>
          </section>
          <blockquote>
            Companies with extremely strong omnichannel customer engagement retain on average 89% of their customers, compared to 33% for companies with weak omnichannel customer engagement.
            <span>Aberdeen Group</span>
          </blockquote>
  
          <section class="features center cols full">
            <div class="mainWrp">
              <h2>Benefits</h2>
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-smile"></i> Improve customer satisfaction</h3>
                  <p>
                    Customers today demand seamless switch across devices. Owning an omni-channel platform will not only provide speed and consistency, it will also improve customers' overall satisfaction level.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-address-book"></i> Up-to-date CRM</h3>
                  <p>
                    All information provided by customers can be automatically transferred and aggregated to the organization’s CRM and entered into the appropriate data fields in real time.​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-chart-line"></i> Increase retention rate</h3>
                  <p>
                    An Omni-channel platform will provide users with same level of customer care while they switch across devices. Everytime a user switches channel, you are locking in the customer while your competitors without omni-channel solution are losing him/her.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-stopwatch"></i> Engage in real-time​</h3>
                  <p>
                    You can keep your customers engaged and satisfied through all your channels, whenever and wherever they need your service.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="features full center cols grey">
            <div class="mainWrp">
              <h2>Features</h2>
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-swatchbook"></i> Personalized</h3>
                  <p>
                    The platform will remember the user preference across channels. By combining scattered pieces together, an aggregated personal experience is delivered.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-language"></i> NLU</h3>
                  <p>
                    Our solution with NLU capability will give the user a more human touch, compared to cold robotic selections.​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-chart-bar"></i> Analytics​</h3>
                  <p>
                    Data is aggregated throughout all channels, providing the most consistent and insightful information to support decision making.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-headphones-alt"></i> Call Center acceleration</h3>
                  <p>
                    Our Customer Service Solution with powerful knowledge library and NLU capability will process user request to reduce CSR cost. Any unsolved issue will immediately acceletate to live agent to ensure customer satisfaction.​
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div class="mainWrp">
            <section>
              { calltoaction }
            </section>
          </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Omnichannel.tsx